// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-2rrjbtFx {\n    margin-top: 25px;\n    margin-bottom: 10px;\n    font: bold 20px/22px 'microsoft yahei';\n    color: #000;\n}\n\n.hotList-3nzzINWZ {\n    font-size: 14px;\n}\n\n.emptyComment-Ipcc1QEu {\n    height: 70px;\n    text-align: center;\n    font: 18px 'Microsoft Yahei';\n    color: #b0bfc4;\n    padding-top: 45px;\n    line-height: 22px;\n}\n", ""]);
// Exports
exports.locals = {
	"title": "title-2rrjbtFx",
	"hotList": "hotList-3nzzINWZ",
	"emptyComment": "emptyComment-Ipcc1QEu"
};
module.exports = exports;
